import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
const TechnologySubSection = ({ data }) => {
  const [technologyData] = useState(data);
  return (
    <Container>
      {technologyData.map((e, index) => {
        return (
          <>
            <Row className="section-container align-items-center" key={index}>
              <Col md={6} id={e.id}>
                <div className="technology-subsection-section">
                  <img src={e.image} alt={e.title} className=" mb-3" />
                  <h6 className="f-4 mb-2">{e.title}</h6>
                  <p className="f-3 mb-3">{e.description}</p>

                  <ul className="d-md-none d-block">
                    {e.features.map((feature) => {
                      return <li>{feature}</li>;
                    })}
                  </ul>

                  <button className="rounded p-2">
                    <a href={e.href} className="">
                     {!e.test ?  "Download" : "Register"}
                    </a>
                  </button>
                </div>
              </Col>
              <Col md={6} className="d-md-block d-none">
                <ul>
                  {e.features.map((feature) => {
                    return <li>{feature}</li>;
                  })}
                </ul>
              </Col>
            </Row>
          </>
        );
      })}
    </Container>
  );
};

export default TechnologySubSection;
